import React, {useContext, useState} from "react";

import {buyNowContext} from "../BuyNow";
import {PRODUCT_CATEGORIES} from "../../../../constants";

/**
 * The MCS Marketplace access product is a simple boolean add-on - the user either purchases it or not.
 * A quantity isn't applicable, so unlike the admin access product, this section only renders a checkbox and the price.
 */
export const McsMarketplaceAccess = () => {
  const {
    appInfo,
    lineItems,
    removeLineItems,
    mcsMarketplaceAccessProducts,
    setLineItemsByCategory,
  } = useContext(buyNowContext);

  const businessName = appInfo.name;
  const mcsMarketplaceAccessProduct = mcsMarketplaceAccessProducts.find(p => p.category === PRODUCT_CATEGORIES.MCS_MARKETPLACE_ACCESS);
  const mcsMarketplaceAccessLineItem = lineItems.find(li => li.product.category === PRODUCT_CATEGORIES.MCS_MARKETPLACE_ACCESS);
  const [isMcsMarketplaceAccessEnabled, setIsMcsMarketplaceAccessEnabled] = useState(!!mcsMarketplaceAccessLineItem);

  // The product isn't available for the current website location, so there is nothing to offer.
  if (!mcsMarketplaceAccessProduct)
    return null;

  const onToggleMcsMarketplaceAccess = event => {
    const isEnabled = event.target.checked;
    setIsMcsMarketplaceAccessEnabled(isEnabled);

    if (isEnabled)
      setLineItemsByCategory([{product: mcsMarketplaceAccessProduct, quantity: 1}]);
    else
      removeLineItems(mcsMarketplaceAccessLineItem);
  };

  return (
    <div className="custom-control custom-checkbox mt-5 col-10 offset-1 col-lg-12 offset-lg-0 px-0">
      <h4 className="text-dark header-txt">
        {`${businessName} Care Platform access`}
      </h4>

      <span className="description-txt text-muted">
        {`Grow your practice and gain exposure to more potential clients through the ${businessName} Marketplace, part of the ${businessName} Care Platform.`}
      </span>

      <div className="row align-items-center mt-4">
        <div className="col-8">
          <div className="form-check d-lg-flex align-items-lg-center px-4 px-lg-0 ps-lg-4">
            <input
              id="mcsMarketplaceAccess"
              type="checkbox" className="form-check-input me-2"
              checked={isMcsMarketplaceAccessEnabled}
              onChange={onToggleMcsMarketplaceAccess}
            />
            <label className="form-check-label plan-main-txt fw-bolder pt-lg-1" htmlFor="mcsMarketplaceAccess">
              {`Add ${businessName} Care Platform Access`}
            </label>
          </div>
        </div>

        <div className="col-4 fw-bold" style={{textAlign: "right"}}>
          <div style={{color: mcsMarketplaceAccessLineItem ? null : "gray"}}>
            {`$${Math.round(mcsMarketplaceAccessProduct.price)}`}
          </div>
        </div>
      </div>
    </div>
  );
};
